<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22"><circle cx="10" cy="10" r="9" stroke="#000" stroke-width="2"/><path stroke="#000" stroke-width="2" d="M5 10h10M10 15V5"/><path stroke="#000" stroke-linecap="round" stroke-width="2" d="m17 17 4 4"/></svg>
</template>
<script>
  export default {
    name: "LoupePlus"
  }
</script>

<style scoped>

</style>